import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

import { PlusArticleTypeTitle } from "scmp-app/components/plus/plus-article-type-title";

export const CoverLink = styled.div`
  border-radius: 4px;

  cursor: pointer;

  img {
    border-radius: 4px;
  }
`;

export const CoverImage = styled.div`
  overflow: hidden;
  aspect-ratio: 3 / 2;
`;

export const Headline = styled.div`
  color: #000000;
  font-weight: 700;
  font-size: 18px;
  line-height: 130%;
`;

export const ContentLink = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  gap: 8px;

  cursor: pointer;
`;

export const StyledPlusArticleTypeTitle = styled(PlusArticleTypeTitle)`
  line-height: normal;
  text-transform: uppercase;
  text-decoration: underline;
`;

export const Footer = styled.div`
  margin-block-start: 4px;

  color: #888888;
  font-size: 14px;
  line-height: 16px;
`;

export const Header = styled.div`
  display: flex;
  flex-flow: column;
  gap: 4px;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  font-family: ${fontRobotoCondensed};
`;
